import * as React from 'react'
import * as Sentry from '@sentry/browser'

import Wrapper from './src/components/Wrapper'
import Layout from './src/components/Layout'

import './src/styles/global.scss'

export const wrapRootElement = Wrapper
export const wrapPageElement = ({ element, props }) => (
  <Layout {...props}>{element}</Layout>
)

const supportsWebp = async () => {
  if (!window.createImageBitmap) return false

  const webpData =
    'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA='
  const blob = await fetch(webpData).then(r => r.blob())

  return createImageBitmap(blob).then(() => true, () => false)
}

export const onClientEntry = async () => {
  // Sentry.init({
  //   dsn: config.sentry.DSN,
  // })
  // window.Sentry = Sentry

  if (typeof Intl === 'undefined') {
    await import('intl')
  }

  if (Intl && !Intl.hasOwnProperty('PluralRules')) {
    await import('intl-pluralrules')
  }

  if (Intl && !Intl.hasOwnProperty('RelativeTimeFormat')) {
    const pathNames = window.location.pathname.split('/')
    await import('@formatjs/intl-relativetimeformat/polyfill')
    if (pathNames.length > 1) {
      try {
        await import(`@formatjs/intl-relativetimeformat/dist/locale-data/${pathNames[1]}`)
      } catch (e) { }
    }
  }

  // Check if client supports webP
  if (await supportsWebp()) {
    if (document) {
      document.body.classList.add('webp-checked')
      document.body.classList.add('support-webp')
    }
  } else {
    document.body.classList.add('webp-checked')
  }
}
